// start:ng42.barrel
export * from './ck-editor-insert-image-plugin.module';
export * from './ck-editor-insert-image-plugin.service';
// end:ng42.barrel

